import styled from '@emotion/styled'
import * as v from '../../../../../variables/styles'

export const CellCont = styled.div((props) => ({
  display: 'flex',
  flexDirection:'column',
  
  '.title':{
    color:'#888888',
    fontSize:'12px'
  },
  '.value':{
    padding:'0.5rem 1rem',
    flex:1,
    border: '1px solid rgba(34,36,38,.15)',
    borderRadius:'0.3rem',
    minHeight:'2.5rem',
    wordBreak: 'break-all',
  },

  '.right':{
    display: 'flex',
    justifyContent: 'flex-end'
  },

  '.areaText':{
    minHeight:'6rem',
    maxHeight:'6rem',
    overflowY:'scroll',
    wordWrap:'anywhere',
    wordBreak:'break-all'
  },

}))


